var JsonWebTokenError = function (message, error) {
  Error.call(this, message);
  Error.captureStackTrace(this, this.constructor);
  this.name = 'JsonWebTokenError';
  this.message = message;
  if (error) this.inner = error;
};

JsonWebTokenError.prototype = Object.create(Error.prototype);
JsonWebTokenError.prototype.constructor = JsonWebTokenError;

module.exports = JsonWebTokenError;


/*****************
 ** WEBPACK FOOTER
 ** ./~/getstream/~/jsonwebtoken/lib/JsonWebTokenError.js
 ** module id = 99
 ** module chunks = 0
 **/